import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=1edf8d2a"
import script from "./RootView.vue?vue&type=script&lang=js"
export * from "./RootView.vue?vue&type=script&lang=js"
import style0 from "./RootView.vue?vue&type=style&index=0&id=1edf8d2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports